import { render } from "./LoadingPage.vue?vue&type=template&id=4cb1a0be&scoped=true"
const script = {}

import "./LoadingPage.vue?vue&type=style&index=0&id=4cb1a0be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb1a0be"]])

export default __exports__